import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import * as _ from "lodash";

import { useAuth } from "@/_zustand/auth";
import { useOneClickComercio } from "@/hooks/useOneClickComercio";
import { MSG_TARJETA_OTRO_COMERCIO } from "@/lib/oneclickCards";
import { hayPagoEnCurso, PAYMENT_MSG_EN_CURSO } from "@/lib/paymentGuard";

export const OneClickButton = () => {
  const navigate = useNavigate();
  const isCompanyFlow = location.pathname.startsWith("/company");
  const { statusAuth, tempCard, setTempCard } = useAuth();
  const { tempCardValida } = useOneClickComercio();

  const authorizeTransaction = () => {
    if (statusAuth != "authed") {
      toast.error("Debe validar su correo para continuar");
      return;
    }
    if (_.size(tempCard) <= 0 || !tempCard.tbk_user) {
      toast.error("Debe seleccionar una tarjeta para continuar");
      return;
    }
    // Segunda barrera (la primera es que el botón deje de renderizarse en
    // CartPage.jsx): un tempCard de otro comercio nunca debe llegar a
    // /pay-detail, que autoriza al montar sin más interacción del usuario.
    if (!tempCardValida) {
      toast.error(MSG_TARJETA_OTRO_COMERCIO);
      setTempCard({});
      return;
    }
    // Impide entrar a /pay-detail mientras el carrito (u otro flujo en esta
    // misma pestaña) ya tiene una autorización OneClick en vuelo — evita que
    // /pay-detail dispare una segunda autorización al montar.
    if (hayPagoEnCurso("oneclick")) {
      toast.error(PAYMENT_MSG_EN_CURSO);
      return;
    }

    navigate(
      isCompanyFlow
        ? "/company/pay-detail?platform=oneclick"
        : "/pay-detail?platform=oneclick",
      { replace: true },
    );
  };

  return (
    // <Button className="order-btn-fill" size="md" onClick={ () => authorizeTransaction()}>
    //   Pagar
    // </Button>
    <button
      type="submit"
      className="order-btn-fill"
      style={{ minWidth: "150px" }}
      disabled={hayPagoEnCurso("oneclick")}
      onClick={() => authorizeTransaction()}
    >
      Pagar
    </button>
  );
};
